import { CREATE_SIGNAL_PATH } from "common/constants.ts";
import { useRouteMatch } from "react-router-dom";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { LanguageNameSpaces } from "@shared/types";

const useCreateTradeTitleString = (): string => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);
  const isSignal = !!useRouteMatch(CREATE_SIGNAL_PATH);
  return isSignal
    ? t("page_title.signals_terminal")
    : t("page_title.trading_terminal");
};

export default useCreateTradeTitleString;
